/**
 * ライブ映像（?live=1。Issue #617）の「ライブへ」。再生バー（PC）と再生タブ（スマホ）の両方に置く。
 * live = { lag（端から何秒遅れているか）, paused, onLive }
 */
import { LIVE_EDGE_SEC } from './liveVideo';

/** ライブ映像（?live=1）のときだけ出す「ライブへ」。端を追っているあいだは赤い印だけ（押しても変わらない） */
export default function LiveButton({ live, style }) {
  if (!live) return null;
  const onEdge = !live.paused && live.lag <= LIVE_EDGE_SEC;
  return (
    <button type="button" data-testid="live-button" data-on-edge={onEdge ? '1' : '0'} onClick={live.onLive} disabled={onEdge}
      style={{ ...style, color: onEdge ? '#ff6b6b' : '#e8eefc', fontWeight: 800 }}>
      ● {onEdge ? 'ライブ' : `ライブへ${live.lag >= 1 ? `（${Math.round(live.lag)} 秒遅れ）` : ''}`}
    </button>
  );
}
